import Route from './discover-routes'

export { Route }
export default {
  Route,
}
